import React from 'react'
import { PropTypes } from 'prop-types'
import InputNumberSpinner from '../input_number_spinner_component'
import UniqId from 'uniqid'
import './people_counter_component.scss'
import { withNamespaces } from "react-i18next"
import { compose } from 'redux'

export class PeopleCounter extends React.Component {
  constructor(props) {
    super(props)
    const { t } = props
    this.state = {
      labels: {
        adult: t('calendar.adult'),
        child: t('calendar.children'),
        infant: t('calendar.infants')
      },
      isShownSelectBox: false
    }
  }

  onClickSelectbox(e) {
    this.setState({ isShownSelectBox: !this.state.isShownSelectBox })
  }

  handleClickOutside(e) {
    this.setState({ isShownSelectBox: false })
  }

  updateNumberValue(param) {
    this.props.updateCounter(param)
  }

  createPulldownText() {
    const result = []
    const labelKeys = Object.keys(this.state.labels)
    const { t } = this.props
    let delimiter = ""
    labelKeys.map((k) => {
      if (this.props[k] > 0) {
        if ( result.length > 0 ) {
          delimiter = '/'
        }
        result.push(<span key={UniqId()}><span>{delimiter}</span><span>{this.state.labels[k]}</span><span className='notranslate'>{this.props[k]}</span><span>{ t('calendar.guest') }</span></span>)
      }
    })
    return result
  }

  getRemainsCount(addedValue) {
    const remains = this.props.maximum_guests ? (this.props.maximum_guests - (this.props.adult + this.props.child)) : -1
    return (remains < 0) ? remains : (addedValue + remains)
  }

  render() {
    const active = (this.state.isShownSelectBox) ? " active" : ""
    const maxAdults = this.getRemainsCount(this.props.adult)
    const maxChildren = this.getRemainsCount(this.props.child)
    const { allowInfants, t } = this.props
    return (
      <div styleName={`people-count-wrap${active}`}>
        <button className="w-select search-reservation-nselect-wrap" styleName="w-select search-reservation-nselect-wrap"
          onClick={this.onClickSelectbox.bind(this)} disabled={this.props.isDisabled}>{this.createPulldownText()}</button>
        <div className={`people-suggest${active}`} styleName="people-suggest">
          <div className="people-suggest-inner">
            <div>
              <InputNumberSpinner element="adult" value={this.props.adult} min={1} max={maxAdults}
                error="" update={this.updateNumberValue.bind(this)}>{ t('calendar.adult') }</InputNumberSpinner>
            </div>
            <div className="mt20">
              <InputNumberSpinner element="child" value={this.props.child} max={maxChildren}
                error="" update={this.updateNumberValue.bind(this)}>{ t('calendar.children') }<div className="sb-input-title-sub">{ t('calendar.children_intro') }</div></InputNumberSpinner>
            </div>
            {
              allowInfants &&
            <div className="mt20">
              <InputNumberSpinner element="infant" value={this.props.infant} max={5}
                error="" update={this.updateNumberValue.bind(this)}>{ t('calendar.infants') }<div className="sb-input-title-sub">{ t('calendar.infants_intro') }</div></InputNumberSpinner>
            </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

PeopleCounter.propTypes = {
  adult: PropTypes.number.isRequired,
  child: PropTypes.number.isRequired,
  infant: PropTypes.number.isRequired,
  updateCounter: PropTypes.func.isRequired,
  maximum_guests: PropTypes.number,
  isDisabled: PropTypes.bool,
  allowInfants: PropTypes.bool.isRequired
}

PeopleCounter.defaultProps = {
  adult: 0,
  child: 0,
  infant: 0,
  updateCounter: () => {},
  maximum_guests: 0,
  isDisabled: false
}

export default compose( withNamespaces('listings') )(onClickOutside(PeopleCounter))
